var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{ref:"chart1",staticClass:"echarts chart chartBox",attrs:{"id":_vm.id,"tyle":"width:100%;height:100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }